import { ClassCode } from "~/assets/scripts/valueObjects/ClassCode"

export function getSpecs(vehicle) {
	const isThisReallyAVehicle = ![ClassCode.Trailer, ClassCode.Glamper].includes(vehicle.classCode)
	const isElectric = vehicle.fuelType === "Electric"

	const ageRange = () => ({
		icon: "time-outline",
		text: vehicle.ageRange === "0" ? "New model" : vehicle.ageRange + " year(s) old",
	})

	const carSampleCc = () => ({
		icon: "engine-outline",
		text: vehicle.carSampleCc + (isElectric ? " kWh battery" : " cc engine"),
	})

	const passengerCapacity = () => ({
		icon: "seats-outline",
		text: vehicle.passengerCapacity + " seats",
	})

	const transmission = () => {
		const transmission = vehicle.transmission.toLowerCase()

		const icon = ["auto", "manual"].includes(transmission)
			? transmission + "-outline"
			: "preferences-outline"

		const text = transmission === "auto"
			? "Automatic"
			: "Manual"

		return {
			icon,
			text,
		}
	}

	const largeLuggageNum = () => ({
		icon: "bag-large-outline",
		text: vehicle.largeLuggageNum + " " + (vehicle.largeLuggageNum > 1 ? "large bags" : "large bag")
	})

	const fuelType = () => ({
		icon: vehicle.fuelType === "Electric" ? "ev-outline" : "fuel-outline",
		text: vehicle.fuelType,
	})

	const smallLuggageNum = () => ({
		icon: "bag-small-outline",
		text: vehicle.smallLuggageNum + " " + (vehicle.smallLuggageNum > 1 ? "small bags" : "small bag")
	})

	const litPer100Pm = () => ({
		icon: "fuel-econ-outline",
		text: vehicle.litPer100Pm + (isElectric ? "km range (est)" : "L / 100km"),
	})

	return [
		ageRange(),
		vehicle.passengerCapacity 	!== 0 	? passengerCapacity()	: null,
		largeLuggageNum(),
		smallLuggageNum(),
		vehicle.carSampleCc 		!== "0"	? carSampleCc() 		: null,
		isThisReallyAVehicle 				? transmission()		: null,
		isThisReallyAVehicle 				? fuelType()			: null,
		vehicle.litPer100Pm 		!== "0"	? litPer100Pm()			: null,
	].filter(Boolean)
}